export default __webpack_public_path__ + "static/media/SaudiTour.8709a475.mp4";